import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import { initErrorLogger } from './services/errorLogger'
import './index.css'

// Initialize error logger (non-blocking, fire-and-forget)
initErrorLogger()

// Debug logging for mobile issues
console.log('[main.tsx] App starting...')
console.log('[main.tsx] User Agent:', navigator.userAgent)
console.log('[main.tsx] Screen:', window.innerWidth, 'x', window.innerHeight)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
)
